export default "__VITE_PUBLIC_ASSET__7a73b3f7__"